import { jsx as _jsx } from "react/jsx-runtime";
import * as RadixDialog from '@radix-ui/react-dialog';
/**
 * Full-viewport bottom sheet. Slides up from the bottom on open, covers the
 * whole screen, and is itself the scroll container so children can use
 * `position: sticky`. No backdrop — the sheet covers everything.
 */
export function Sheet({ open, onOpenChange, ariaLabel, style, children }) {
    return (_jsx(RadixDialog.Root, { open: open, onOpenChange: onOpenChange, children: _jsx(RadixDialog.Portal, { children: _jsx(RadixDialog.Content, { "aria-label": ariaLabel, style: style, className: "fixed inset-0 z-40 flex flex-col overflow-y-auto bg-white outline-none data-[state=open]:animate-[deallock-sheet-up_220ms_ease-out]", children: children }) }) }));
}
export const SheetTitle = RadixDialog.Title;
export const SheetClose = RadixDialog.Close;
